<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="modal-terms">
    <div class="modal-header">
      <div class="icon-ajuntament" />
      <div class="icon-close" @click="modalClose" />
    </div>
    <div class="modal-content">
      <div v-if="termsData">
        <div v-if="termsData.code === 500" class="cms-error">
          <span>{{ $t('not_cms') }}</span>
        </div>
        <div v-else class="terms-page has-side-bars">
          <div v-cms="termsData[0].htmldefinition" class="terms-def" />
        </div>
      </div>
      <div v-else-if="cmsError" class="cms-error">
        <span>{{ $t('not_cms') }}</span>
      </div>
      <div v-else>
        <Loader :text="$t('loading')" />
      </div>
    </div>
    <div class="buttons-wrapper">
      <div class="button-accept" @click="modalClose">
        <span>{{ $t('agree') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { vCmsHtml as cms, getCMSWebpages } from '@/services/graphql'
import Loader from '../Loader.vue'
/**
 * Renders a modal with news info
 * @example [none]
 */
export default {
  name: 'ModalTerms',
  directives: { cms },
  components: { Loader },
  props: {
    /**
     * Function for close the modal
     */
    modalClose: {
      type: Function,
    },
  },
  data() {
    return {
      cmsError: false,
    }
  },
  asyncComputed: {
    termsData() {
      return getCMSWebpages(this.$store.state.i18n.lang, 'terms').then(resp => {
        if (resp.code === 500) this.cmsError = true
        return resp
      })
    },
  },
  computed: {},
  methods: {},
}
</script>

<style lang="stylus" scoped>
.modal-terms
  display: flex
  flex-direction: column
  height: 100%
  justify-content: space-between
  width: 100%
  z-index: 10

  h3
    m-font-size(32, 45)
    font-weight: 600
    margin-block-end: 0
    margin-block-start: 0
    margin-left: vw(20px)

  .buttons-wrapper
    display: flex
    margin-bottom: vw(30px)
    margin-left: vw(20px)

    .button-accept
      background-color: black
      border: 1px solid black
      border-radius: 4px
      color: white
      cursor: pointer
      display: flex
      padding: vw(8px) vw(15px)

      &:hover
        background-color: $grey-dark

      span
        m-font-size(14, 20)

  .terms-title
    m-font-size(26, 30)
    color: $grey-dark
    font-weight: 600
    text-align: center

  .modal-content
    display: flex
    flex-direction: column
    height: "calc(100% - %s)" % vw(250px)
    overflow-y: scroll
    padding: vw(5px) vw(30px)
    m-font-size(16, 20)

    .terms-page
      display: flex
      flex-direction: column
      gap: vw(6px)

      .terms-def
        m-font-size(18, 24)
        color: $grey-dark

    .cms-error
      align-items: center
      display: flex
      justify-content: center
      min-height: vw(200px)

      span
        m-font-size(20, 26)
        color: black
        font-weight: 400

  .modal-header
    height: vw(62px)
    position: relative
    width: 100%

    .icon-ajuntament
      background-image: url("~@/assets/logos/logo-ajuntament-barcelona-rounded.svg")
      background-position: center center
      background-repeat: no-repeat
      background-size: cover
      height: vw(45px)
      margin-left: vw(20px)
      margin-top: vw(20px)
      width: vw(176px)

    .icon-close
      m-icon("modal-close", 32, $grey-dark)
      cursor: pointer
      position: absolute
      right: vw(20px)
      top: vw(20px)

.cms-error
  display: flex
  justify-content: center
  margin-top: vw(20px)
  padding-bottom: vw(30px)
  width: 100%

  span
    m-font-size(20, 26)
    color: black
    font-weight: 400
</style>
